/**
 * URL の path から creative パラメータを生成する
 *
 * URL の query string に vcp が含まれる場合は、pathname に campaign パラメータを付与した上で creative パラメータに連携する。
 *
 * @param {Object} params - params
 * @param {string} params.pathname - pathname
 * @param {string} params.pathname - search
 * @return {string} - creativeのurlクエリ(adjust用)
 */
export const generateCreativeQuery = ({
  pathname,
  search,
}: {
  pathname: string;
  search: string;
}) => {
  if (pathname === '') {
    return '';
  }
  const campaignQuery = new URLSearchParams(search).get('vcp');
  return `creative=${encodeURIComponent(
    `${campaignQuery ? `${pathname}?campaign=${campaignQuery}` : `${pathname}`}`
  )}`;
};

export const adjustLinkPattern =
  /href\s*=\s*('|")https:\/\/app\.adjust\.com\/((?!\1).)*(?=\1)/gi;
